import './AnimatedBrandText.css';
import { useState } from 'react';
import { useTeamBrand } from '../branding/TeamBrandContext';

export default function AnimatedBrandText({ children, className = '' }) {
  const brand = useTeamBrand();
  const [failedUrl, setFailedUrl] = useState('');
  const label = children == null ? (brand.active ? brand.name : 'Xiaoying') : brand.text(children);
  if (children == null && brand.active && brand.wordmarkUrl && failedUrl !== brand.wordmarkUrl) return (
    <span className={`xiaoying-brand-lockup xiaoying-brand-lockup--image ${className}`.trim()}>
      <img className="xiaoying-brand-lockup__image" src={brand.wordmarkUrl} alt={brand.name} onError={() => setFailedUrl(brand.wordmarkUrl)} />
    </span>
  );
  return (
    <span className={`xiaoying-brand-lockup ${className}`.trim()}>
      <span className="xiaoying-brand-text">{label}</span>
      <span className="xiaoying-brand-spark" aria-hidden="true">✦</span>
    </span>
  );
}
